/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { BA_ACTION, ENTITYNAME, LOCALSTORAGE_KEY, TOAST_TYPES } from "../../framework/constant/constant";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useTranslation } from "../../locale/useTranslation";
import EditRoundButton from "../../framework/forms/helpercomponents/buttons/EditRoundButton";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import SaveRoundButton from "../../framework/forms/helpercomponents/buttons/SaveRoundButton";
import CancelRoundButton from "../../framework/forms/helpercomponents/buttons/CancelRoundButton";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import IMDBEditForm from "./IMDBEditForm";
import BossAssistantIcon from "./component/BossAssistantIcon";
import { utility } from "../../framework/utility/utilityProvider";
import CastTypeEditForm from "../masters/CastTypeEditForm";
import ToastNotification from "../../components/ToastNotification";

function MediaEpisodeCastAndCrewEditForm(props) {

  const [dataItem, setDataItem] = useState({
    Name: "",
    CastType: {},
    Language: {}
  });

  const [castTypes, setCastTypes] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [showIMDbForm, setShowIMdbForm] = useState(false);
  const [languages, setLanguages] = useState([]);

  const lang = useTranslation();
  const selectedIndexRef = useRef(0);
  const setSelectedIndexRef = (data) => {
    selectedIndexRef.current = data;
  }

  const defaultFormState = {
    CastType: false,
  }
  const [showEditForm, setShowEditForm] = useState(defaultFormState);

  useEffect(() => {
    loadCombo();
  }, [props?.language])

  const loadCombo = async () => {
    let castTypeRes = await API.getDataLookup(ENTITYNAME.CastType, { sort: { Description: 1 }, query: ["Archive", "!=", true] });
    if (props?.language && Object.keys(props?.language)?.length > 0) {
      setCastTypes(castTypeRes.data.filter((x) =>
        !x?.Language ||
        x?.Language?._id == props?.language?._id ||
        x?.Language?.Description == props?.language?.Description
      ));
      setDataItem({ Name: '', CastType: {} });
    } else {
      setCastTypes(castTypeRes.data);
    }
    let langRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
    setLanguages(langRes.data);
    if (langRes.data?.length > 0) {
      setDataItem({ ...dataItem, Language: langRes.data[0] });
    }
  }

  const onChange = (e) => {
    setDataItem({ ...dataItem, [e.target.name]: e.target.value });
  };

  const MyCommandCell = (props) => (
    <div style={{ display: "flex" }}>
      <EditRoundButton onClick={() => editCastAndCrewButton(props)} />
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeCastAndCrew(props.dataIndex), () => { })} />
    </div>
  )

  const editCastAndCrewButton = (data) => {
    let dataItem = data.dataItem;
    setSelectedIndexRef(data.dataIndex);
    setDataItem(dataItem);
    setToggle(true);
    setEditMode(true);
  }

  const isValidforadd = () => {
    if (dataItem.Name == "") {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_name_cast_crew_media_episode_error_message });
      return false;
    }
    if (!dataItem.CastType || Object.keys(dataItem.CastType).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_casttype_cast_crew_media_episode_error_message });
      return false;
    }
    if (dataItem.Language == undefined || Object.keys(dataItem.Language).length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_language_media_episode_cast_and_crew_error_message });
      return false;
    }
    return true;
  }

  const addCastAndCrew = (index) => {
    if (isValidforadd()) {
      const dataNew = {
        ...dataItem,
        Language: typeof dataItem.Language === "string" ? JSON.parse(dataItem.Language) : dataItem.Language,
        CastType: typeof dataItem.CastType === "string" ? JSON.parse(dataItem.CastType) : dataItem.CastType,
      }
      props.setCastAndCrew([...props.data, dataNew]);
      setDataItem({ Name: '' });
      clearData();
    }
  }

  const removeCastAndCrew = (index) => {
    props.setCastAndCrew([
      ...props.data.slice(0, index),
      ...props.data.slice(index + 1, props.data.length)
    ]);
    clearData();
    ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
  }

  const editCastAndCrew = () => {
    if (isValidforadd()) {
      let local = [...props.data]
      local[selectedIndexRef.current] = dataItem;
      props.setCastAndCrew(local);
      setEditMode(false);
      clearData();
    }
  }

  const clearData = () => {
    setDataItem({ Name: '', CastType: {}, Language: {} });
    setEditMode(false);
    setToggle(false);
  }

  const handleIMDbdataList = (data) => {
    console.log(data);
    let castAndCrewActor = data?.Actors?.split(',').map((item) => {
      return {
        Name: item,
        CastType: castTypes.find((x) => x.Description === "Actors")
      }
    });
    let castAndCrewDirector = data?.Director?.split(',').map((item) => {
      return {
        Name: item,
        CastType: castTypes.find((x) => x.Description === "Director")
      }
    });
    let castAndCrewWriter = data?.Writer?.split(',').map((item) => {
      return {
        Name: item,
        CastType: castTypes.find((x) => x.Description === "Writer")
      }
    });

    let castAndCrew = [...castAndCrewActor, ...castAndCrewDirector, ...castAndCrewWriter];
    let uniqueCastAndCrew = castAndCrew.filter(item => {
      return !props.data.some(existingItem => existingItem.Name == item.Name && existingItem.CastType.Description == item.CastType.Description);
    });
    props.setCastAndCrew([...props.data, ...uniqueCastAndCrew]);
    setShowIMdbForm(false);

  }

  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.CastAndCrew, item, props.mediaData);
    console.log(aiDataRes);
    return aiDataRes;

  }

  const onCreateMasterClick = (key) => {
    setShowEditForm({
      ...defaultFormState,
      [key]: true
    });
  }

  const setCastAndCrewData = (newData) => {

    console.log("HERE IN MEDIA EPISODE CAST AND CREW DATA")
    console.log(newData);

    let newCCData = [];
    newData.forEach((item) => {

      let language = languages.find((x) => x.Description == (item?.Language?.Description ?? props?.language?.Description));
      let cast = castTypes.find((x) => x.Description == item.CastType.Description);
      if (!cast) {
        cast = castTypes.find((x) => x.Description == "Actor");
      }

      newCCData.push({
        Language: { _id: language._id, Description: language.Description, ISOCode: language?.ISOCode },
        CastType: { _id: cast?._id, SID: cast?.SID, Description: cast?.Description },
        Name: item.Name,
      });

    });

    let finalData = utility.removeDuplicate([...props.data, ...newCCData], "Name");
    props.setCastAndCrew(finalData);

  }

  return (<>
    <div className="row">
      {!toggle && <div className="col-12">
        <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <AddRoundButton onClick={() => setToggle(true)} />
            <RoundButton icon="fa fa-file-text" title={lang.update_imdb_label} onClick={() => setShowIMdbForm(true)} />
          </div>
          <BossAssistantIcon
            style={{}}
            mediaEpisodeEntity={props.mediaData}
            iconSize={"35px"}
            onDataLoad={onBossAIMetaDataLoad}
            popupTtle={"Generate Cast and Crew"}
            tooltip={"Generate full Cast and Crew with Boss AI"}
            description={"BOSS AI Generating Cast and Crew"}
            setMetaData={setCastAndCrewData}
          />
        </div>
        <Grid data={props.data} style={{ height: "30vh" }}>
          <GridColumn cell={MyCommandCell} width={"70px"} locked={true} />
          <GridColumn field="CastType.Description" title={lang.cast_column} editable={false} />
          <GridColumn field="Language.Description" title={lang.language_column} editable={false} />
          <GridColumn field="Name" title={lang.name_column} editable={false} />
        </Grid>
      </div>}
      {toggle && <div className="col-6" style={{ paddingTop: "30px" }}>
        <Grid data={props.data} style={{ height: "30vh" }}>
          <GridColumn cell={MyCommandCell} width={"70px"} locked={true} />
          <GridColumn field="CastType.Description" title={lang.cast_column} editable={false} />
          <GridColumn field="Language.Description" title={lang.language_column} editable={false} />
          <GridColumn field="Name" title={lang.name_column} editable={false} />
        </Grid>
      </div>}
      {toggle && <div className="col-6">
        {!editMode && <AddRoundButton onClick={() => addCastAndCrew()} />}
        {editMode && <SaveRoundButton onClick={() => { editCastAndCrew() }} />}
        <CancelRoundButton onClick={clearData} />
        <div className="row ml-2" >
          <div className="col-12 mt-2" style={{ border: "groove 1px" }}>
            <div className="row mt-2">
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="TabView">{lang.cast_type_label} *</label><br />
                  <div style={{ display: 'flex' }}>
                    <DropDownList
                      style={{ backgroundColor: "white" }}
                      data={castTypes}
                      name="CastType"
                      textField="Description"
                      dataItemKey="_id"
                      value={dataItem.CastType}
                      onChange={onChange}
                    />
                    <button type="button" title={lang.create_cast_type_button_tooltip} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary "
                      style={{ height: "29px", margin: '0px 0px 0px 5px' }} onClick={() => { onCreateMasterClick('CastType') }}><i className="fa-solid fa-plus fa-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label htmlFor="TabView">{lang.language_label} *</label><br />
                  <DropDownList
                    style={{
                      backgroundColor: "white",
                    }}
                    data={languages}
                    name="Language"
                    textField="Description"
                    dataItemKey="_id"
                    value={dataItem.Language}
                    onChange={onChange}
                    validator={(value) => value ? "" : "Please select the value"}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label htmlFor="">{lang.name_label} *</label>
                  <input type="text" className="form-control form-control-sm" name="Name" value={dataItem.Name} onChange={(e) => onChange(e)} required />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>}
    </div>
    {showIMDbForm && <IMDBEditForm mediaCategory={props?.mediaData?.MediaCategory?.SID} IMDbID={props?.mediaData?.IMDbID ?? ""} imdbDataList={handleIMDbdataList} cancelEdit={() => setShowIMdbForm(false)} />}
    {showEditForm.CastType && <CastTypeEditForm item={{ SID: 0 }} cancelEdit={() => setShowEditForm({ CastType: false })} refresh={() => loadCombo()} />}

  </>)
}

export default MediaEpisodeCastAndCrewEditForm
